import config, {GOOGLE_ADS} from './config'

const getGoogleAdsScriptUrl = () => {
  const {CONVERSION_ID, SCRIPT_BASE_URL} = config[GOOGLE_ADS]

  return `${SCRIPT_BASE_URL}${CONVERSION_ID}`
}

export const googleAdsScriptUrl = getGoogleAdsScriptUrl()
